import { render } from "./eduEvaLesson.vue?vue&type=template&id=36e70d50&scoped=true"
import script from "./eduEvaLesson.vue?vue&type=script&lang=js"
export * from "./eduEvaLesson.vue?vue&type=script&lang=js"

import "./eduEvaLesson.vue?vue&type=style&index=0&id=36e70d50&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e70d50"]])

export default __exports__